module.exports = __webpack_public_path__ + "media/images/corredizo-061a681e.png";